import React, {useMemo, useState} from 'react'
import PropTypes from 'prop-types'

import {
    Flex,
    Box,
    useMediaQuery,
    Stack
} from '@salesforce/retail-react-app/app/components/shared/ui'

import './Scroller.scss'
import LeftButton from './buttons/left'
import RightButton from './buttons/right'
import ScrollerHeader from './scroller-header'
import {useWindowWidth} from '../../utils/site-utils'
import Link from '../link'

const MobileScroller = ({data}) => {
    const [startIndex, setStartIndex] = useState(0)

    const [xs] = useMediaQuery('(max-width:500px)')
    const cta = data?.cta?.fields

    const width = useWindowWidth()
    const {items, maxVisible} = useMemo(() => {
        const cards = data?.items ?? []

        const maxToShow = xs ? 1 : Math.floor((width - 170) / 170)
        return {
            items: cards,
            maxVisible: Math.min(maxToShow, Math.max(1, cards?.length))
        }
    }, [data, xs, width])

    const handlePrev = () => setStartIndex((prev) => Math.max(prev - 1, 0))
    const handleNext = () =>
        setStartIndex((prev) => Math.min(prev + 1, items?.length - maxVisible))

    const visibleCards = useMemo(
        () => items?.slice(startIndex, startIndex + maxVisible),
        [startIndex, maxVisible]
    )

    const canBack = startIndex > 0
    const canNext = startIndex < items?.length - maxVisible

    return (
        <Flex
            flexFlow="column"
            width="100%"
            justifyContent="center"
            alignItems="center"
            gap="20px"
        >
            <ScrollerHeader title={data?.heading} />
            <Box className="carousel-container">
                <LeftButton
                    onClick={() => canBack && handlePrev()}
                    active={canBack}
                    width="20px"
                    height="25px"
                />

                <Box className="carousel-track" minHeight="284px">
                    {visibleCards.map((card, index) => (
                        <Box className="carousel-card" key={index}>
                            {card}
                        </Box>
                    ))}
                </Box>

                <RightButton
                    onClick={() => canNext && handleNext()}
                    active={canNext}
                    width="20px"
                    height="25px"
                />
            </Box>
            {cta && (
                <Stack width="max-content">
                    <Link
                        buttonStyles={{
                            fontWeight: '300',
                            fontSize: '16px',
                            color: 'black',
                            textDecoration: 'underline'
                        }}
                        _hover={{
                            fontWeight: 'bold'
                        }}
                        {...cta}
                    />
                </Stack>
            )}
        </Flex>
    )
}

MobileScroller.displayName = 'ProductCarousel'

MobileScroller.propTypes = {
    data: PropTypes.shape({
        heading: PropTypes.string,
        cta: PropTypes.object,
        sys: PropTypes.shape({
            id: PropTypes.string
        }),
        items: PropTypes.arrayOf(PropTypes.obj)
    })
}

export default MobileScroller
